import { List } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ListIcon = DeckardIconWrapper({ Icon: List });
